import React from 'react';
import { motion } from 'framer-motion';

interface DragDropHintProps {
  isVisible: boolean;
  message?: string;
  type?: 'info' | 'success' | 'error' | 'warning';
  position?: { x: number; y: number } | null;
}

export const DragDropHint: React.FC<DragDropHintProps> = ({
  isVisible,
  message = '拖拽到正确的省份位置',
  type = 'info',
  position = null
}) => {
  if (!isVisible) return null;

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          bg: 'bg-green-500',
          text: 'text-white',
          icon: '✅'
        };
      case 'error':
        return {
          bg: 'bg-red-500',
          text: 'text-white',
          icon: '❌'
        };
      case 'warning':
        return {
          bg: 'bg-yellow-500',
          text: 'text-white',
          icon: '⚠️'
        };
      default:
        return {
          bg: 'bg-blue-500',
          text: 'text-white',
          icon: '🎯'
        };
    }
  };

  const styles = getTypeStyles();

  // 跟随鼠标的小提示 - 更加轻量
  if (position) {
    return (
      <motion.div
        className="fixed z-50 pointer-events-none"
        style={{
          left: position.x + 10,
          top: position.y - 35,
        }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.1 }}
      >
        <div className={`${styles.bg} ${styles.text} px-2 py-1 rounded text-xs font-medium shadow-lg max-w-40`}>
          <div className="flex items-center space-x-1">
            <span className="text-sm">{styles.icon}</span>
            <span className="truncate">{message}</span>
          </div>
        </div>
      </motion.div>
    );
  }

  // 如果没有位置信息，不显示任何提示（避免遮挡地图）
  return null;
};
